import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { SecretService } from '../../services/secret.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationServiceAPIConfiguration, ConfigurationServiceApi } from '@configuration-client';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { SupplyStackToastrService } from '@slickss/supplystack-components';
import { HttpClient } from '@angular/common/http';
import {Settings} from '@ct-client';

@Component({
    templateUrl: 'landing-page.component.html',
    styleUrls: ['landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit {
    public portalName = '';
    public configurationApi;
    public configurationService;

    constructor(
        private loadingService: LoadingService,
        private secretService: SecretService,
        public translate: TranslateService,
        private router: Router,
        private toastrService: SupplyStackToastrService,
        private http: HttpClient
    ) {
        this.configurationApi = new ConfigurationServiceAPIConfiguration(environment.configurationServiceUrl, this.http);
        this.configurationService = new ConfigurationServiceApi(this.configurationApi);
    }

    ngOnInit() {
        this.loadingService.unsetMajorLoading();
    }

    public getPortalAndNavigate() {
        if (!!this.portalName && this.portalName.length > 4) {
            this.configurationService.getCustomerPortalConfiguration(this.portalName).subscribe(
                () => {
                    this.router.navigate([`${this.portalName}`]);
                },
                () => {
                    this.toastrService.openNotificationToastr('The portal requested doesn\'t exist', false);
                }
            );
        } else {
            this.toastrService.openNotificationToastr('Invalid portal name', false);
        }
    }

    get customerName() {
        return this.secretService.getConfiguration() ? this.secretService.getConfiguration().niceName : 'Transporeon';
    }

    get termsLink(): string {
        return this.getLink( this.secretService.getPortalSettings(),  'sTermsLink');
    }

    get privacyLink(): string {
        return this.getLink( this.secretService.getPortalSettings(),  'sPrivacyPolicyLink');
    }

    private getLink(setting: Settings, linkName: string) {
        if (!setting || !setting[linkName]) {
            return '';
        }

        const url = setting[linkName];
        if (url.indexOf('http:') >= 0 || url.indexOf('https:') >= 0) {
            return url;
        } else {
            return `https://${url}`;
        }
    }

    public changeLanguage(event) {
        this.translate.use(event);
    }
}
